import type { PageAction } from '@/contexts/PageChromeContext';

/** Labelled action buttons shown at once, counting the primary. */
const VISIBLE_ACTION_BUDGET = 3;

/**
 * Splits secondary actions into buttons and the ⋯ menu. The primary spends one
 * of the visible slots; mobile folds every secondary.
 */
export function splitActions(
    actions: PageAction[],
    { hasPrimary, compact }: { hasPrimary: boolean; compact: boolean },
): { visible: PageAction[]; overflow: PageAction[] } {
    const slots = compact ? 0 : VISIBLE_ACTION_BUDGET - (hasPrimary ? 1 : 0);
    return { visible: actions.slice(0, slots), overflow: actions.slice(slots) };
}
